import React from 'react';
import { Link } from 'react-router-dom';
import Item from './SidebarItem';

import LayoutContext from '../../../store/Layout/contexts';

import logo from '../../../assets/images/logos/powertrack.png';

const Sidebar = ({
  type,
  items,
  currentUrlPath,
  setDropdownActive,
  dropdownActive,
}) => {
  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => (
        <div
          style={{ minWidth: '255px', width: '255px', borderLeftColor: '#ccc' }}
          className={!activeSidebar ? 'd-none' : 'container border-end'}
        >
          <Link
            to={'/'}
            className="list-group-item border-0 text-decoration-none py-2 text-center"
            style={{ color: 'inherit' }}
          >
            <img
              src={logo}
              alt=""
              className="py-3"
              style={{ maxWidth: '150px' }}
            />
          </Link>
          {items.map((item, index) => {
            if (
              (!item.auth && item.menu_auth) ||
              (item.auth && item.auth.some((level) => level === type)) ||
              item.menu_auth
            ) {
              return (
                <Item
                  key={index}
                  item={item}
                  currentUrlPath={currentUrlPath}
                  setDropdownActive={setDropdownActive}
                  dropdownActive={dropdownActive}
                />
              );
            }
          })}
        </div>
      )}
    </LayoutContext.Consumer>
  );
};

export default Sidebar;
